import axios, { CostHeaderParamsType, createCostHeader, serverInstance } from '@/shared/axios';
import {
  InsHashTagModel,
  InsHashTagSearchModel,
  InsPostCommentExportListModel,
  InstagramAnonymouslyModel,
  InstagramHighlightsDetailModel,
  InstagramPostsCommentsItemModel,
  InstagramPostsCommentsModel,
  InstagramPostsLikesModel,
  InstagramQueryPostsModel,
  InstagramStoriesDetailModel,
  InstagramUserSubModel,
  PostAnalysisModel,
  PostCommentAnalysisModel,
} from '@/types/anonymously.interface';
import { SearchLimitLeftModel } from '@/types/home';
import { BaseResponse } from '@/types/web.interface';

export async function fetchInstagramAnonymouslySearchData(
  media_name?: any,
  captcha_token?: string,
  locale?: string,
  // is_lock?: number,
  options?: CostHeaderParamsType
) {
  const res = await axios.get<BaseResponse<InstagramAnonymouslyModel>>(`/ins/story/story/search`, {
    params: {
      media_name,
    },
    headers: {
      'captcha-token': captcha_token || '',
      'Current-Language': locale,
      // 'is-lock': is_lock,
      ...createCostHeader(options),
    },
  });
  return res.data;
}

export async function fetchInstagramAnonymouslyDemoData(media_name?: any, locale?: string) {
  const res = await serverInstance.get<BaseResponse<InstagramAnonymouslyModel>>(`/ins/story/story/demo`, {
    params: {
      media_name,
    },
    headers: {
      'Current-Language': locale,
    },
  });
  return res.data;
}

export async function fetchInstagramAnonymouslyTimesData(locale?: string) {
  const res = await axios.get<BaseResponse<SearchLimitLeftModel>>(`/ins/story/search/left`, {
    headers: {
      'Current-Language': locale,
    },
  });
  return res.data;
}

// 同步剩余搜索次数
export async function syncRemainingInstagramAnonymouslyTimesData(locale?: string) {
  const res = await axios.post<BaseResponse<undefined>>(`/ins/story/search/use`, {
    headers: {
      'Current-Language': locale,
    },
  });
  return res.data;
}

export async function fetchInstagramAnonymouslyStoryDetailData(storyId?: any, locale?: string) {
  const res = await axios.get<BaseResponse<InstagramStoriesDetailModel>>(`/ins/story/detail/${storyId}`, {
    params: {
      storyId,
    },
    headers: {
      'Current-Language': locale,
    },
  });
  return res.data;
}

export async function fetchInstagramAnonymouslyHighlightsDetailData(highlightsId?: any, locale?: string) {
  const res = await serverInstance.get<BaseResponse<InstagramHighlightsDetailModel>>(
    `/ins/story/highlights/detail/${highlightsId}`,
    {
      params: {
        highlightsId,
      },
      headers: {
        'Current-Language': locale,
      },
    }
  );

  return res.data;
}

export async function fetchInstagramAnonymouslyHighlightsDetailDataClient(highlightsId?: any, locale?: string) {
  const res = await axios.get<BaseResponse<InstagramHighlightsDetailModel>>(
    `/ins/story/highlights/detail/${highlightsId}`,
    {
      params: {
        highlightsId,
      },
      headers: {
        'Current-Language': locale,
      },
    }
  );

  return res.data;
}

// 查询帖子数据
export async function fetchInsFamousQueryPostsData(
  media_name: any,
  page_token?: string,
  options?: CostHeaderParamsType
) {
  const res = await axios.post<BaseResponse<InstagramQueryPostsModel>>(
    `/ins/famous/query/posts`,
    {
      media_name,
      page_token,
    },
    {
      headers: createCostHeader(options),
    }
  );
  return res.data;
}

// 查询帖子数据
export async function fetchInsStoryPosts(
  media_name: any,
  page_token?: string,
  captcha_token?: string,
  options?: CostHeaderParamsType
) {
  const res = await axios.get<BaseResponse<InstagramQueryPostsModel>>(`/ins/story/posts`, {
    params: {
      media_name,
      page_token,
    },
    headers: {
      'captcha-token': captcha_token,
      ...createCostHeader(options),
    },
  });

  return res.data;
}

// 查询帖子数据
export async function fetchInsStoryReels(
  media_name: any,
  page_token?: string,
  captcha_token?: string,
  options?: CostHeaderParamsType
) {
  const res = await axios.get<BaseResponse<InstagramQueryPostsModel>>(`/ins/story/reels`, {
    params: {
      media_name,
      page_token,
    },
    headers: {
      'captcha-token': captcha_token,
      ...createCostHeader(options),
    },
  });
  return res.data;
}

// 获取帖子评论数据
export async function fetchInsFamousPostCommentsData(code: string, pagination_token?: string) {
  const res = await axios.get<BaseResponse<InstagramPostsCommentsModel>>(`/ins/famous/post/comments/${code}`, {
    params: {
      pagination_token,
    },
  });
  return res.data;
}

// 获取帖子点赞数据（无分页）
export async function fetchInsFamousPostLikesData(code: string, options?: CostHeaderParamsType) {
  const res = await axios.get<BaseResponse<InstagramPostsLikesModel>>(`/ins/famous/post/like/${code}`, {
    headers: createCostHeader(options),
  });
  return res.data;
}

// 用户需求收集，暂时没有额外参数，仅是针对帖子评论查看更多评论这个需求点
export async function sendInsFamousRequireAddRequest() {
  const res = await axios.post<BaseResponse<undefined>>(`/ins/famous/require/add`);
  return res.data;
}

export async function fetchInsHashtagListData() {
  const res = await serverInstance.get<BaseResponse<[InsHashTagModel]>>(`/ins/hashtag`);
  return res.data;
}

export async function searchInsHashtagListData(keyword?: string, options?: CostHeaderParamsType) {
  const res = await axios.get<BaseResponse<[InsHashTagSearchModel]>>(`/ins/hashtag/search`, {
    params: {
      keyword,
    },
    headers: createCostHeader(options),
  });
  return res.data;
}

// 观看视频领取奖励 /ins/reward/claim
export async function fetchInsRewardClaimData(reward_type: string) {
  const res = await axios.post<BaseResponse<undefined>>(`/ins/reward/claim`, {
    reward_type,
  });
  return res.data;
}

// post comments
export async function fetchInsPostCommentPostData(
  media_name: string,
  page_token?: string,
  options?: CostHeaderParamsType
) {
  const res = await axios.post<BaseResponse<InstagramQueryPostsModel>>(
    `/ins/post-comment/post-data`,
    {
      media_name,
      page_token,
    },
    {
      headers: createCostHeader(options),
    }
  );
  return res.data;
}

// 用户订阅内容

export async function fetchInsPostCommentUserSubData() {
  const res = await axios.get<BaseResponse<InstagramUserSubModel>>(`/ins/post-comment/credit/info`);
  return res.data;
}

// 分析
export async function fetchInsPostCommentAnalysisData(
  comments: InstagramPostsCommentsItemModel[],
  options: CostHeaderParamsType
) {
  const res = await axios.post<BaseResponse<PostCommentAnalysisModel>>(
    `/ins/post-comment/comment-sentiment`,
    {
      comments,
    },
    {
      headers: createCostHeader(options),
    }
  );
  return res.data;
}

export async function fetchInsFamousPostCommentPostsData(
  code: string,
  pagination_token?: string,
  options?: CostHeaderParamsType
) {
  const res = await axios.post<BaseResponse<InstagramPostsCommentsModel>>(
    `/ins/post-comment/comments/${code}`,
    {
      pagination_token,
    },
    {
      headers: createCostHeader(options),
    }
  );
  return res.data;
}

//post分析
export async function fetchInsPostCommentPostAnalysisData(username: string, options: CostHeaderParamsType) {
  const res = await axios.post<BaseResponse<PostAnalysisModel>>(
    `/ins/post-comment/post-analysis`,
    {
      username,
    },
    {
      headers: createCostHeader(options),
    }
  );
  return res.data;
}

export async function fetchInsFamousPostSubCommentPostsData(
  code: string,
  pk: string,
  pagination_token?: string,
  options?: CostHeaderParamsType
) {
  const res = await axios.post<BaseResponse<InstagramPostsCommentsModel>>(
    `/ins/post-comment/comment-reply/${code}/${pk}`,
    {
      pagination_token,
    },
    {
      headers: createCostHeader(options),
    }
  );
  return res.data;
}

export async function fetchInsCommentExport(code: string, data: unknown, options: CostHeaderParamsType) {
  const res = await axios.post<BaseResponse<InstagramPostsCommentsModel>>(
    `/ins/post-comment/comments/${code}/export`,
    data,
    {
      headers: createCostHeader(options),
    }
  );
  return res.data;
}

export async function fetchInsCommentExportList() {
  const res = await axios.get<BaseResponse<InsPostCommentExportListModel[]>>(`/ins/post-comment/comments/exportList`);
  return res.data;
}

export async function fetchInsInviteLink() {
  const res = await axios.post<BaseResponse<{ referral: string }>>(`/ins/referral/createReferral`);
  return res.data;
}

export async function fetchInsReferralLink(referral: string) {
  const res = await axios.post<BaseResponse<undefined>>(`/ins/referral/submitReferral`, {
    referral,
  });
  return res.data;
}

export async function fetchInsReferralLinkStatus() {
  const res = await axios.get<BaseResponse<{ referral: string }>>(`/ins/referral/invitedStatus`);
  return res.data;
}

export async function fetchNeedVerify() {
  const res = await axios.get<BaseResponse<boolean>>(`/ins/story/currentVerifyStatus`);
  return res.data;
}
